export default __webpack_public_path__ + "static/media/datafarming-hr-imagery-terms.ada3a603.pdf";